export const SHORT_TIME_FORMAT = "h:mm A";
